import { reskinStyles } from 'core/components/theme/theme-variant';

// Reskin: quote's menu colors (ui-core `action.hover` bark50, `action.selected` beige50 at bold weight),
// so the chosen option stands out and hover reads as a highlight rather than a border.
const overrideListItems = (theme) => {
  const hovered = { backgroundColor: theme.colorPalette.orange_on_dark, color: theme.colors.text_primary };
  theme.overrides.MuiListItem = {
    root: {
      // Reskin: keyboard focus gets the hover highlight, since the global focus outline is off for options.
      ...reskinStyles(theme, { '&$focusVisible': { backgroundColor: theme.colorPalette.orange_on_dark } }),
      '&$selected': {
        backgroundColor: theme.colorPalette.white,
        fontWeight: 600,
        ...reskinStyles(theme, { backgroundColor: theme.colorPalette.beige_25, fontWeight: 700 }),
        '&:hover': {
          backgroundColor: theme.colorPalette.green_75_op_10,
          ...reskinStyles(theme, hovered)
        }
      }
    },
    button: {
      '&:hover': {
        color: theme.palette.common.green_100,
        backgroundColor: theme.colorPalette.green_75_op_10,
        ...reskinStyles(theme, hovered)
      }
    }
  };
};

export default overrideListItems;
